import React from "react";
import styles from "../../TeacherList/TeacherModal.module.sass";
import Button from "../../../Button";
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import axios from 'axios';
import makeAnimated from 'react-select/animated';
const animatedComponents = makeAnimated();
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const TeacherForm = ({ teachers, teacher, studentGroups, setStudentGroups }) => {
  const { register, handleSubmit, control } = useForm({ defaultValues: { name: teacher.name,
      display_name: teacher.display_name, grade: teacher.grade,
      display_grade: teacher.display_grade } });

  const formatStudents = () => {
    const emptyStudent = { value: '', label: 'Remove' }
    const formattedStudents = teachers.map(student => (
      { value: student.id,label: `${student.first_name} ${student.last_name}` }
    ))

    return (
      [emptyStudent, ...formattedStudents]
    )
  }

  const defaultValue = () => {
    const studentRecord = formatStudents().find(s => s.value === teacher.student_id);

    return (
      { value: teacher.student_id, label: studentRecord && studentRecord.label }
    )
  }

  const onSubmit = (data) => {
    axios
      .put(`/api/v1/educators/${teacher.id}`,
        { data:
            {
              type: 'educators',
              id: teacher.id,
              attributes: {
                name: data.name,
                display_name: data.display_name,
                grade: data.grade,
                display_grade: data.display_grade,
                student_id: data.student_id && data.student_id.value,
              }
            }
        })
      .then(() => {
        toast('Teacher was saved successfully', { type: 'success' })
      })
  }

  return (
    <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <ToastContainer position="bottom-left" />

      <label className={styles.label}>Name</label>
      <input
        className={styles.input}
        {...register("name")}
      />
      <label className={styles.label}>Display Name</label>
      <input
        className={styles.input}
        {...register("display_name")}
      />
      <label className={styles.label}>Grade</label>
      <input
        className={styles.input}
        {...register("grade")}
      />
      <label className={styles.label}>Display Grade</label>
      <input
        className={styles.input}
        {...register("display_grade")}
      />
      <label className={styles.label}>Associated Student Record</label>
      <Controller
        control={control}
        defaultValue={defaultValue()}
        name="student_id"
        render={({ field, value }) => (
          <Select
            {...field}
            className="basic-single"
            components={animatedComponents}
            defaultValue={defaultValue()}
            options={formatStudents()}
            name="student_id"
            value={formatStudents().find(s => s.value === value)}
          />)}
      />
      <br/>
      <Button
        classes={styles.submit}
        variant='submit'
      >
        Save
      </Button>
    </form>
  )
}

export default TeacherForm;
